var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecharge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 6H10.5C10.8 6 11 6.2 11 6.5C11 6.8 10.8 7 10.5 7H8.5V9H10.5C10.8 9 11 9.2 11 9.5C11 9.8 10.8 10 10.5 10H8.5V11.5C8.5 11.8 8.3 12 8 12C7.7 12 7.5 11.8 7.5 11.5V10H5.5C5.2 10 5 9.8 5 9.5C5 9.2 5.2 9 5.5 9H7.5V7H5.5C5.2 7 5 6.8 5 6.5C5 6.2 5.2 6 5.5 6H6.4L5.7 5.3C5.5 5.1 5.5 4.8 5.7 4.6C5.9 4.4 6.2 4.4 6.4 4.6L7.8 6H8.3L9.7 4.6C9.9 4.4 10.2 4.4 10.4 4.6C10.6 4.8 10.6 5.1 10.4 5.3L9.7 6ZM8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 15C11.9 15 15 11.9 15 8C15 4.1 11.9 1 8 1C4.1 1 1 4.1 1 8C1 11.9 4.1 15 8 15Z",
    fill: "#000022",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.107d303d92fa908622e7779caad5a005.svg";
export { ForwardRef as ReactComponent };